<template>
	<div>
		<div class="btn d-none d-md-block btn-danger btn-lg" v-on:click="deleteFile(  fileId )"><i class="fas fa-trash"></i></div>
	</div>
</template>

<script>
	export default {
		props: [
		'fileId'
		],

		methods: {
			deleteFile(fileId) {
				
				console.log('fileId', fileId);

				let formData = new FormData();
				formData.append('fileId', fileId);

				axios.post( '/manage/files/delete', formData )
				.then(function(data) {
					console.log(data);
					window.location.reload(true);
				}.bind(this)).catch(function(data) {
					console.log('error', data);
				});


			},
		},


	}
</script>



// WEBPACK FOOTER //
// resources/js/components/RemoveFile.vue